import { render, staticRenderFns } from "./RefundReason.vue?vue&type=template&id=316828ac&scoped=true"
import script from "./RefundReason.vue?vue&type=script&lang=js"
export * from "./RefundReason.vue?vue&type=script&lang=js"
import style0 from "./RefundReason.vue?vue&type=style&index=0&id=316828ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316828ac",
  null
  
)

export default component.exports